import { H3 } from '@h3/types';
const scheduleMappings = require('!!raw-loader!./local-plugins/schedule/ui/properties/ScheduleMappings.vue');
const scheduleDesign = require('!!raw-loader!./local-plugins/schedule/ui/design.vue');
const scheduleRuntime = require('!!raw-loader!./local-plugins/schedule/ui/runtime2.vue');

export const localPlugins: H3.Plugin.Next.IPluginInstance[] = [
    {
        auth: [],
        author: '',
        code: 'schedule',
        description: '',
        engineCode: '',
        extension: [],
        helpLinkUrl: '',
        hook: '',
        icon: 'https://static.h3yun.com/common-resource/pc/common/images/logo-color.svg',
        name: '日程',
        publishedTime: '',
        id: '',
        version: '0.0.1',
        status: 1,
        isLocal: true,
        ui: [
            {
                createSchema: true,
                dataType: H3.Control.BizDataType.String,
                definition: '',
                design: {
                    code: scheduleDesign.default,
                    isDefault: true,
                    properties: [
                        {
                            key: 'ScheduleMappings',
                            name: '字段配置',
                            code: scheduleMappings.default,
                            required: true,
                            type: 31,
                        },
                    ],
                },
                runtime: {
                    pcCode: scheduleRuntime.default,
                    pcViewCode: '',
                    mobileCode: '',
                    mobileViewCode: '',
                },
            },
        ],
    },
];
